import { Pipe, PipeTransform } from '@angular/core';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';

dayjs.extend(customParseFormat);

@Pipe({
    name: 'expiryDate',
    standalone: false
})
export class ExpiryDatePipe implements PipeTransform {

  transform(expiry_date: any) {
    if (!expiry_date) return 'N/A';

    const today = dayjs().startOf('day');
    const expiry = dayjs(expiry_date, ['MM-DD-YYYY', 'YYYY-MM-DD'], true).startOf('day');

    if (!expiry.isValid()) return 'N/A';

    const diff = expiry.diff(today, 'days');
    const isToday = diff === 0;
    const isExpired = diff < 0;
    const expiredDays = Math.abs(diff);

    switch (true) {
      case isToday:
        return 'Expiring Today';
      case isExpired:
        return `Expired ${expiredDays} ${expiredDays === 1 ? 'day' : 'days'} ago`;
      default:
        return expiry.format('MMMM DD, YYYY');
    }
  }

}
